import { Vector3 } from "@babylonjs/core";
import calculateDistanceBetweenPoints from "./calculateDistanceBetweenPoints";
import { MINIMUM_DISTANCE } from "../constants";

const isLessThanMinimumDistance = (position1: Vector3, position2: Vector3)=>{
    return calculateDistanceBetweenPoints(position1, position2) < MINIMUM_DISTANCE;
}

export default isLessThanMinimumDistance;